import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { validateInviteCode } from '../lib/inviteService';
import './InvitePage.css';

const APP_SCHEME_INVITE_URL = 'mytravo:///invite';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mytravo.app';
const INVALID_CODE_REDIRECT_DELAY_MS = 4000;

function InvitePage() {
  const { code = '' } = useParams();
  const navigate = useNavigate();
  const normalizedCode = code.toUpperCase();
  const [status, setStatus] = useState('checking');
  const [errorMsg, setErrorMsg] = useState(null);
  const [copied, setCopied] = useState(false);

  const isAndroid = /android/i.test(navigator.userAgent);

  useEffect(() => {
    let cancelled = false;
    let redirectTimer;

    const checkCode = async () => {
      let result;
      try {
        result = await validateInviteCode(normalizedCode);
      } catch {
        result = { valid: false, reason: 'Erreur réseau. Impossible de vérifier ce lien d\'invitation.' };
      }
      if (cancelled) return;

      if (result.valid) {
        setStatus('valid');
        return;
      }

      setErrorMsg(result.reason);
      setStatus('invalid');
      redirectTimer = setTimeout(() => navigate('/login', { replace: true }), INVALID_CODE_REDIRECT_DELAY_MS);
    };

    checkCode();

    return () => {
      cancelled = true;
      clearTimeout(redirectTimer);
    };
  }, [normalizedCode, navigate]);

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(normalizedCode);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  if (status === 'checking') {
    return (
      <div className="App">
        <p className="App-loading">Vérification du lien…</p>
      </div>
    );
  }

  if (status === 'invalid') {
    return (
      <div className="App">
        <div className="App-card">
          <h1 className="App-title">
            My<span>Travo</span>
          </h1>
          <p className="App-status is-error">{errorMsg}</p>
          <p className="Invite-help">Redirection vers la page de connexion…</p>
          <button
            type="button"
            className="App-submit"
            onClick={() => navigate('/login', { replace: true })}
          >
            Aller à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="App-card">
        <h1 className="App-title">
          My<span>Travo</span>
        </h1>
        <p className="App-subtitle">Vous êtes invité à rejoindre un chantier</p>

        <button type="button" className="Invite-code" onClick={copyCode}>
          <span className="Invite-codeValue">{normalizedCode}</span>
          <span className="Invite-codeHint">{copied ? 'Code copié' : 'Toucher pour copier'}</span>
        </button>

        <a className="App-submit Invite-open" href={`${APP_SCHEME_INVITE_URL}/${encodeURIComponent(normalizedCode)}`}>
          Ouvrir dans MyTravo
        </a>

        <p className="Invite-help">
          Si l'application ne s'ouvre pas, installez MyTravo puis saisissez ce code dans
          « Rejoindre un chantier ».
        </p>

        {isAndroid && (
          <a className="Invite-store" href={PLAY_STORE_URL}>
            Télécharger sur Google Play
          </a>
        )}
      </div>
    </div>
  );
}

export default InvitePage;
